import { SpinnerIcon } from "@talladega/icons";
import classNames from "classnames";

export type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl";
export type SpinnerSpeed = "slow" | "normal" | "fast";

export type AnimatedSpinnerProps = {
  className?: string;
  size?: SpinnerSize;
  speed?: SpinnerSpeed;
};

const sizeClasses: Record<SpinnerSize, string> = {
  xs: "size-4",
  sm: "size-8",
  md: "size-12",
  lg: "size-16",
  xl: "size-24",
};

const speedClasses: Record<SpinnerSpeed, string> = {
  slow: "animate-[spin_2s_linear_infinite]",
  normal: "animate-spin", // Tailwind's default spin is 1s
  fast: "animate-[spin_0.5s_linear_infinite]",
};

export const AnimatedSpinner = ({
  className,
  size = "lg",
  speed = "normal",
}: AnimatedSpinnerProps) => {
  return (
    <div className="flex items-center justify-center" aria-label="Loading...">
      <SpinnerIcon
        className={classNames(
          className,
          sizeClasses[size],
          speedClasses[speed]
        )}
      />
    </div>
  );
};

export default {};
